import React from "react";

export default (props: {
  visible: Boolean;
  content: string;
  position: { x: number; y: number };
}) => {
  const { visible, content, position } = props;

  return (
    <div
      style={{
        pointerEvents: "none",
        position: "fixed",
        display: visible ? "block" : "none",
        width: 200,
        left: position.x ? position.x : 0,
        top: position.y ? position.y : 0,
        textAlign: "center",
        boxShadow:
          "0 2.8px 2.2px rgba(0, 0, 0, 0.07), 0 6.7px 5.3px rgba(0, 0, 0, 0.033), 0 12.5px 10px rgba(0, 0, 0, 0.022), 0 22.3px 17.9px rgba(0, 0, 0, 0.019)",

        minWidth: 50,
        minHeight: 50,
        background: "lightgray",
        borderRadius: 15,
        padding: 15
      }}
    >
      {content}
    </div>
  );
};
